import { IReason } from 'Model/IReason';
import { CONSTANTS } from './../../../utils/constants'
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { isEmail } from "utils";
import { IManagementVehicle } from 'Model/IManagementVehicle';

const ValidateReasonType = (reason: IReason) => {
    let isValid = false;
    if (reason.reasonType === undefined || reason.reasonType === null || reason.reasonType === "" || reason.reasonType == "Select Reason Type") {
        reason.reasonTypeError = "Please select reason type";
    } else {
        reason.reasonTypeError = "";
        isValid = true;
    }
    reason.shipToDealerError = " ";
    return { isValid, reason };
}

const ValidateShipToLocation = (reason: IReason) => {
    let isValid = false;
    if (reason.requestType != CONSTANTS.PRODUCTION_VEHICLE && reason.requestType != CONSTANTS.MANAGEMENT_VEHICLE) {
        if (reason.shipToLocation === undefined || reason.shipToLocation === null || reason.shipToLocation === "" || reason?.shipToLocation?.trim()?.length == 0) {
            reason.shipToDealerError = "Please enter ship to location";
        } else if (reason.shipToLocation.length > 150) {
            reason.shipToDealerError = "Please enter ship to location less than 150 characters";
        } else {
            reason.shipToDealerError = "";
            isValid = true;
        }
    } else {
        reason.shipToDealerError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateComments = (reason: IReason) => {
    let isValid = false
    if (reason?.comments?.length > 300) {
        reason.commentsError = "Please enter comments less than 300 characters";
    } else {
        reason.commentsError = "";
        isValid = true
    }
    return { isValid, reason };
}

const ValidateAttachments = (reason: IReason) => {
    let isValid = false;
    if (reason.requestType == CONSTANTS.NON_STANDARD_EQUIPMENT || (reason.requestType == CONSTANTS.MANAGED_EQUIPMENT && reason.showQuotePrice)|| (reason.requestType == CONSTANTS.MANAGEMENT_VEHICLE && reason.showQuotePrice)|| (reason.requestType == CONSTANTS.PRODUCTION_VEHICLE && reason.showQuotePrice)) {
        if (reason.attachments.length <= 0) {
            reason.attachmentsError = "Please attach a link"
        } else {
            reason.attachmentsError = ""
            isValid = true
        }
    } else {
        reason.attachmentsError = ""
        isValid = true;
    }
    return { isValid, reason }

}

const ValidateVehicleDriverDetails = (request: IManagementVehicle, reasonList: any) => {
    let reasonCount = 0;
    for (let i = 0; i < reasonList.length; i++) {
        if (reasonList[i]?.requestIndex === request?.requestIndex && reasonList[i]?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
            reasonCount = reasonCount + 1
        }
    }
    let isValid = false;
    if (request?.vehicleDriverDetails.length <= 0 || request?.vehicleDriverDetails.length != reasonCount) {
        request.vehicleDriverDetailsError = "Driver is required"
    } else {
        request.vehicleDriverDetailsError = ""
        isValid = true;
    }
    return { isValid, request }
}

//growth
const ValidateNewEmployeeBusiness = (reason: IReason) => {
    let isValid = false;
    if (reason.newEmployeeBusiness === undefined || reason.newEmployeeBusiness === null || reason.newEmployeeBusiness === "" || reason.newEmployeeBusiness == "Select New Employee/Business") {
        reason.newEmployeeBusinessError = "Please select New Employee/Business";
    } else {
        reason.newEmployeeBusinessError = "";
        isValid = true;
        if (reason.jobIdOrEmpId === undefined || reason.jobIdOrEmpId === null || reason.jobIdOrEmpId === "") {
            if (reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE) {
                reason.jobIdOrEmpIdError = '';
            }
            else if (reason.newEmployeeBusiness == CONSTANTS.NEW_BUSINESS) {
                reason.jobIdOrEmpIdError = ' ';
            }
        }
    }
    return { isValid, reason };
}

const ValidateJobIdOrEmpId = (reason: IReason) => {
    let isValid = false;
    if (reason.jobIdOrEmpId === undefined || reason.jobIdOrEmpId === null || reason.jobIdOrEmpId === "" || reason?.jobIdOrEmpId?.trim()?.length == 0) {
        if (!reason.jobIdOrEmpId && reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE && !reason?.showNewEmployee) {
            reason.jobIdOrEmpIdError = "Please enter employee id"
        } else if (reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE) {
            isValid = true;
        }
        else if (reason.newEmployeeBusiness == CONSTANTS.NEW_BUSINESS) {
            reason.jobIdOrEmpIdError = "Please enter job";
        }
    } else if (reason.jobIdOrEmpId.length > 12) {
        if (reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE) {
            reason.jobIdOrEmpIdError = "Please enter employee less than 12 characters";
        } else {
            reason.jobIdOrEmpIdError = "Please enter job less than 12 characters";
        }
    } else {
        reason.jobIdOrEmpIdError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateJobOrEmpName = (reason: IReason) => {
    let isValid = false;
    if (reason.jobOrEmpName === undefined || reason.jobOrEmpName === null || reason.jobOrEmpName === "" || reason?.jobOrEmpName?.trim()?.length == 0) {
        if (reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE) {
            reason.jobOrEmpNameError = "Please enter employee name";
        } else {
            reason.jobOrEmpNameError = "Please enter job name";
        }
    } else if (reason.jobOrEmpName.length > 50) {
        if (reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE) {
            reason.jobOrEmpNameError = "Please enter employee name less than 50 characters";
        } else {
            reason.jobOrEmpNameError = "Please enter job name less than 50 characters";
        }
    }
    else {
        reason.jobOrEmpNameError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateSalesAmount = (reason: IReason) => {
    let salesAmountValue = reason?.salesAmount?.replace(/,/g, "")
    let isValid = false;
    if (reason.salesAmount === undefined || reason.salesAmount === null || reason.salesAmount === "" || reason.salesAmount == "0" || reason?.salesAmount?.trim()?.length == 0) {
        reason.salesAmountError = "Please enter sales amount";
    } else if (salesAmountValue?.length > 18) {
        reason.salesAmountError = "Please enter sales amount less than 17 digits.";
    } else {
        reason.salesAmountError = "";
        isValid = true;
    }
    return { isValid, reason };
}

//Planned & Unplanned
const ValidateMileageHourMeter = (reason: IReason) => {
    let isValid = false;
    // Skip validation if asset has been disposed
    if (reason.replacementAssetDisposalDate) {
        reason.mileageHourMeterError = "";
        isValid = true;
        return { isValid, reason };
    }
    let mileageHourMeterValue = getOnlyNumbers(reason?.mileageHourMeter)
    if (reason.mileageHourMeter === undefined || reason.mileageHourMeter === null || reason.mileageHourMeter === "" || reason.mileageHourMeter == "0" || reason?.mileageHourMeter?.trim()?.length == 0) {
        reason.mileageHourMeterError = "Please enter Mileage";
    } else if (mileageHourMeterValue?.length > 9) {
        reason.mileageHourMeterError = "Please enter Mileage less than 9 digits";
    } else {
        reason.mileageHourMeterError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateAnticipatedDisposalPrice = (reason: IReason) => {
    let isValid = false;
    // Skip validation if asset has been disposed
    if (reason.replacementAssetDisposalDate) {
        reason.anticipatedDisposalPriceError = "";
        isValid = true;
        return { isValid, reason };
    }
    if ((reason.anticipatedDisposalPrice === undefined || reason.anticipatedDisposalPrice === null || reason.anticipatedDisposalPrice === "" || reason?.anticipatedDisposalPrice?.trim()?.length == 0) && (reason?.status != "" && reason?.status != "Select Status")) {
        reason.anticipatedDisposalPriceError = "Please enter anticipated disposal price";
    } else {
        reason.anticipatedDisposalPriceError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateAnticipatedDisposalPriceLength = (reason: IReason) => {
    let anticipatedDisposalValue = reason?.anticipatedDisposalPrice?.replace(/,/g, "")
    let isValid = false;
    if (anticipatedDisposalValue !== undefined && anticipatedDisposalValue?.length > 18) {
        reason.anticipatedDisposalPriceLengthError = "Please enter anticipated disposal price less than 17 digits.";
    } else {
        reason.anticipatedDisposalPriceLengthError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidatePlannedReason = (reason: IReason) => {
    let isValid = false;
    // Skip validation if asset has been disposed
    if (reason.replacementAssetDisposalDate) {
        reason.reasonError = "";
        isValid = true;
        return { isValid, reason };
    }
    if (reason.reason === undefined || reason.reason === null || reason.reason === "" || reason?.reason?.trim()?.length == 0) {
        reason.reasonError = "Please enter reason";
    } else if (reason.reason.length > 100) {
        reason.reasonError = "Please enter reason less than 100 characters";
    } else {
        reason.reasonError = "";
        isValid = true;
    }
    return { isValid, reason };
}

const ValidateCondition = (reason: IReason) => {
    let isValid = false;
    // Skip validation if asset has been disposed
    if (reason.replacementAssetDisposalDate) {
        reason.conditionError = "";
        isValid = true;
        return { isValid, reason };
    }
    if (reason.condition === undefined || reason.condition === null || reason.condition === "" || reason.condition == "Select Condition") {
        reason.conditionError = "Please select condition";
    } else {
        reason.conditionError = "";
        isValid = true;
    }
    return { isValid, reason };
}


const ValidateAsset = (reason: IReason) => {
    let isValid = false;
    if (reason.asset === undefined || reason.asset === null || reason.asset === "") {
        reason.assetError = "Please enter valid Replaced Asset No";
    }
    else if (reason.isValidAsset == false) {
        if (reason?.asset?.length > 15) {
            reason.assetError = "Please enter Replaced Asset less than 15 characters.";
        }
        else if (reason.assetError?.length == 0) {
            reason.assetError = "Click 'Get Asset Info' button to validate";
        }
    }
    else {
        reason.assetError = "";
        isValid = true;
    }
    return { isValid, reason };
}

/// Managed Equipment quote Price fields validation
const ValidateQuotePrice = (reason: IReason) => {
    let quotePriceValue = reason?.quotePrice?.replace(/,/g, "")
    let isValid = false
    if (reason.quotePrice === undefined || reason.quotePrice === "" || reason.quotePrice === null || reason?.quotePrice?.trim()?.length == 0 || reason?.quotePrice == "0.00") {
        reason.quotePriceError = "Please enter quote price";
    } else if (quotePriceValue?.length > 18) {
        reason.quotePriceError = "Please enter quote price less than 17 digits";
    } else {
        reason.quotePriceError = "";
        isValid = true
    }
    return { isValid, reason };
}

const ValidateName = (reason: IReason) => {
    let isValid = false
    if (reason.name === undefined || reason.name === "" || reason.name === null || reason?.name?.trim()?.length == 0) {
        reason.nameError = "Please enter name";
    } else if (reason?.name?.length > 50) {
        reason.nameError = "Please enter name less than 50 characters";
    } else {
        reason.nameError = "";
        isValid = true
    }
    return { isValid, reason };
}

const ValidateContact = (reason: IReason) => {
    let isValid = false
    if (reason.contact === undefined || reason.contact === "" || reason.contact === null || reason?.contact?.trim()?.length == 0) {
        reason.contactError = "Please enter contact";
    } else if (reason?.contact?.length > 100) {
        reason.contactError = "Please enter Contact less than 100 characters";
    } else {
        reason.contactError = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidatePhone = (reason: IReason) => {
    let isValid = false
    let phoneVal = reason?.phone?.match(/\d/g);
    // console.log(phoneVal, "phoneVal")
    if (reason?.phone == "" || reason?.phone == undefined || reason?.phone == undefined || phoneVal === null || phoneVal.length < 10 || phoneVal?.toString().trim()?.length == 0) {
        reason.phoneError = "Please enter valid phone";
    } else {
        reason.phoneError = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateEmail = (reason: IReason) => {
    let isValid = false
    const emailRegex = isEmail(reason.email);
    if (reason.email === undefined || reason.email === "" || reason.email === null || emailRegex) {
        reason.emailError = "Please enter valid email address";
    } else if (reason?.email?.length > 50) {
        reason.emailError = "Please enter Email Address less than 50 characters";
    } else {
        reason.emailError = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateAddressLine1 = (reason: IReason) => {
    let isValid = false
    if (reason.addressLine1 === undefined || reason.addressLine1 === "" || reason.addressLine1 === null || reason?.addressLine1?.trim()?.length == 0) {
        reason.addressLine1Error = "Please enter address line 1";
    } else if (reason?.addressLine1?.length > 200) {
        reason.addressLine1Error = "Please enter Address Line 1 less than 200 characters";
    } else {
        reason.addressLine1Error = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateAddressLine2 = (reason: IReason) => {
    let isValid = false
    if (reason?.addressLine2?.length > 200) {
        reason.addressLine2Error = "Please enter Address Line 2 less than 200 characters";
    } else {
        reason.addressLine2Error = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateAddressLine3 = (reason: IReason) => {
    let isValid = false
    if (reason?.addressLine3?.length > 200) {
        reason.addressLine3Error = "Please enter Address Line 3 less than 200 characters";
    } else {
        reason.addressLine3Error = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateDealerCity = (reason: IReason) => {
    let isValid = false
    if (reason.city === undefined || reason.city === "" || reason.city === null || reason?.city?.trim()?.length == 0) {
        reason.cityError = "Please enter city";
    } else if (reason?.city?.length > 100) {
        reason.cityError = "Please enter City less than 100 characters.";
    } else {
        reason.cityError = "";
        isValid = true;
    }
    return { isValid, reason };
}
const ValidateDealerState = (reason: IReason) => {
    let isValid = false
    if (reason.state === undefined || reason.state === "" || reason.state === null || reason?.state?.trim()?.length == 0) {
        reason.stateError = "Please enter state";
    } else if (reason?.state?.length > 2) {
        reason.stateError = "Please enter state less than 2 characters.";
    }
    else {
        reason.stateError = "";
        isValid = true
    }
    return { isValid, reason };
}
const ValidateZip = (reason: IReason) => {
    let isValid = false
    if (reason.zipCode === undefined || reason.zipCode === "" || reason.zipCode === null || reason?.zipCode?.trim()?.length == 0) {
        reason.zipCodeError = "Please enter zip code";
    } else if (reason.zipCode?.length > 10) {
        reason.zipCodeError = "Please enter zip code less than 10 digits.";
    } else {
        reason.zipCodeError = "";
        isValid = true
    }
    return { isValid, reason };
}

const ValidateReason = (reason: IReason) => {
    let isValid = true;    

    let validationResponse = ValidateReasonType({ ...reason })
    if (!validationResponse.isValid) {
        isValid = false;
    }


    validationResponse = ValidateAttachments(validationResponse.reason)
    if (!validationResponse.isValid) {
        isValid = false;
    }

    validationResponse = ValidateComments(validationResponse.reason)
    if (!validationResponse.isValid) {
        isValid = false;
    }

    if (reason.reasonType === CONSTANTS.REASON_GROWTH) {
        
        validationResponse = ValidateNewEmployeeBusiness(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateJobIdOrEmpId(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateJobOrEmpName(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        if (reason.newEmployeeBusiness === CONSTANTS.NEW_BUSINESS) {
            validationResponse = ValidateSalesAmount(validationResponse.reason)
            if (!validationResponse.isValid) {
                isValid = false;
            }
        }

    }
    else if (reason.reasonType === CONSTANTS.REASON_PLANNED || reason.reasonType === CONSTANTS.REASON_UNPLANNED) {

        validationResponse = ValidateAsset(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateMileageHourMeter(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }
        if (reason?.status != "" && reason?.status != "Select Status") {
            validationResponse = ValidateAnticipatedDisposalPrice(validationResponse.reason)
            if (!validationResponse.isValid) {
                isValid = false;
            }
        }

        validationResponse = ValidateAnticipatedDisposalPriceLength(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateCondition(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        if (reason.reasonType === CONSTANTS.REASON_UNPLANNED) {
            validationResponse = ValidatePlannedReason(validationResponse.reason)
            if (!validationResponse.isValid) {
                isValid = false;
            }
        }

    }
    else {
        // console.log("New Reason Type Found")
    }
    if (reason?.requestType == CONSTANTS.MANAGED_EQUIPMENT || reason?.requestType == CONSTANTS.MANAGEMENT_VEHICLE && reason?.showQuotePrice || CONSTANTS.PRODUCTION_VEHICLE && reason?.showQuotePrice) {
        validationResponse = reason?.showQuotePrice ? ValidateQuotePrice(validationResponse.reason) : {isValid: true, reason: validationResponse.reason}
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateName(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateContact(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidatePhone(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateEmail(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateAddressLine1(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateAddressLine2(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateAddressLine3(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateDealerCity(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateDealerState(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateZip(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = ValidateAttachments(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }
    }
    if(reason?.requestType == CONSTANTS.NON_STANDARD_EQUIPMENT){
        validationResponse = ValidateAttachments(validationResponse.reason)
        if (!validationResponse.isValid) {
            isValid = false;
        }
    }
    let reasonTemp = validationResponse.reason;
    reasonTemp.isValid = isValid;

    return reasonTemp;
}

export default {
    ValidateReasonType,
    ValidateShipToLocation,
    ValidateNewEmployeeBusiness,
    ValidateJobIdOrEmpId,
    ValidateJobOrEmpName,
    ValidateSalesAmount,
    ValidateMileageHourMeter,
    ValidateAnticipatedDisposalPrice,
    ValidateAnticipatedDisposalPriceLength,
    ValidatePlannedReason,
    ValidateCondition,
    ValidateAsset,
    ValidateReason,
    ValidateAttachments,
    ValidateName,
    ValidateAddressLine1,
    ValidateAddressLine2,
    ValidateAddressLine3,
    ValidateEmail,
    ValidateContact,
    ValidatePhone,
    ValidateDealerCity,
    ValidateDealerState,
    ValidateZip,
    ValidateQuotePrice,
    ValidateVehicleDriverDetails,
    ValidateComments
}
